export default __webpack_public_path__ + "static/media/paradigma_logo2.5e6e7301.png";